module.exports = __webpack_public_path__ + "img/1931-Black Justice.89704652.png";